import { Apollo } from 'src/gql/generated';

import type { SkillSaveError } from './skill-save-error';

/** Refetched after every change the skills list shows. */
export const SKILLS_LIST_REFETCH = [{ query: Apollo.GetAgentSkillsDocument, variables: {} }];

const OUTDATED_MESSAGES = {
  discard: 'This skill changed before discarding. Reload to review the latest version.',
  publish: 'This skill changed before publishing. Reload to review the latest version.',
  share: 'This skill changed before sharing. Reload before changing its access.',
} as const;

/** The error shown when someone saved a newer version before the action reached the server. */
export function getOutdatedSkillError(action: keyof typeof OUTDATED_MESSAGES): SkillSaveError {
  return { message: OUTDATED_MESSAGES[action], outdated: true };
}

export function getErrorMessage(error: unknown, fallback: string): string {
  return error instanceof Error ? error.message : fallback;
}
